import styled from '@emotion/styled';

const Title = styled.h1`
  color: ${props => props.theme.foregroundTextColor};

  font-size: 2.5rem;
  font-weight: 600;
  letter-spacing: 0.05em;

  margin-left: 1.5em;
  margin-right: 1.5em;
  margin-top: 1em;

  ${props =>
    props.evenMargins
      ? `
    margin-bottom: 1em;
  `
      : `
    margin-bottom: 0.6em;
  `}

  text-align: center;

  svg {
    margin-bottom: -0.2em;
    margin-right: 0.15em;
  }
`;

export default Title;
